import { Component, OnInit } from '@angular/core';
import { HomeComponent } from '../home/home.component';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import {Router,ActivatedRoute} from "@angular/router";
import { PaymentService } from "../../core/services/payment.service";
import { UserorderService } from "../../core/services/userorder.service";
import {Errors} from "../../core/models";
import { decimalDigest } from '@angular/compiler/src/i18n/digest';


 

@Component({
  selector: 'app-qrcode',
  templateUrl: './qrcode.component.html',
  styleUrls: ['./qrcode.component.scss']
})
export class QrcodeComponent implements OnInit {
  state:any;
  hello:any;
  

  mobileNumber = ''
  errors: Errors = {errors: {}};
  mobilePattern = "^\\\d{9}$";
  loginForm: FormGroup;
  submitted = false; 
  mobile = '';
  reference = '';  
  qrcode = '';
 
  isSubmitting = false;
  image = null;
  
  
   productValue = window.localStorage.getItem('productValue');
   value1 =  (parseInt(this.productValue)  ).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  firstval = (parseFloat(this.productValue) / 3).toFixed(2).split(".")[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  secondval = (parseFloat(this.productValue) / 3).toFixed(2).split(".")[1].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  
   
 

  constructor(
    private router:Router,
    private actRoute: ActivatedRoute,
    private route:ActivatedRoute,
    private fb: FormBuilder,
    private paymentService: PaymentService,
    private userorderService: UserorderService 
  ) {  this.state = this.hello; }

  ngOnInit(): void {
   
     
    this.isSubmitting = true;
    this.image = null;
    var order;
    this.errors = {
      errors: {}
    };

     this.qrcode = window.localStorage.getItem('qrcode');

    const formData = this.fb.group({
      grant_type:"password",  
    });

    
    localStorage.setItem('orderid',  this.qrcode.split("orders/")[1].split('?mobile')[0]  );


    order = setInterval(() => {
      
      this.paymentService
      .payment(formData)
        .subscribe(  
          (data) => {  
            
            
           localStorage.setItem('orderNo',  data['content'].orderNo  );
           
           if( data['content'].status == "Fully Payed"){
            clearTimeout(order);
            this.router.navigateByUrl('merchant/order/verify')
           }
           if( data['content'].status == "Payment failed due to timeout or ineligibility"){
            clearTimeout(order);
            this.router.navigateByUrl('merchant/order/verifyfail')
           }
           if( data['content'].status == "Partially Payed"){
            clearTimeout(order);
            this.router.navigateByUrl('merchant/order/verify')
           } 
 
          } 
        )

    }, 10000);
   
  }
  backtohome() {
    this.router.navigateByUrl('')
  }
  backtocalcel(){

    const orderId = window.localStorage.getItem('orderid');  
      this.userorderService
      .ordercancel(orderId)
      .subscribe( (data) => {  
            if(data['statusCode'] == '200'){ 
              this.router.navigateByUrl('merchant/order')
            };
        },
        (err)=> {
          // if(err['statusCode'] == '400'){ 
          //   this.router.navigateByUrl('merchant/order')
          // };
        }
        
      )
   
  }
  twodecimal(amount) {
    const numb = (Math.round(amount * 100) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","); 
    return numb;
  }
}
